export default "__VITE_ASSET__BzmccO5x__"